export const roles = {
    "1" : "Application Super Admin",
    "2" : "Product Admin",
    "3" : "Campaign Admin",
    "4" : "Campaign User",
    "5" : "Call Center"
}